import { ColumnButton } from 'lib/components/ColumnButton';
import { formatOptions } from './SelectPublisherDropdown';

type PublisherResultCardProps = {
  publisher: ReturnType<typeof formatOptions>;
  onSelect: (publisherId: string) => void;
  tags?: React.ReactNode[];
};

export function PublisherResultCard({
  publisher,
  onSelect,
  tags
}: PublisherResultCardProps) {
  return (
    <div
      className="flex w-full justify-between items-end border border-column-gray-200 p-2 rounded-md space-y-2"
      key={publisher.value}
    >
      <div className="space-y-1">
        <h2 className="text-md mb-0 pb-0 text-column-gray-700 font-semibold">
          {publisher.label}
        </h2>
        <span className="text-xs font-normal">{publisher.description}</span>
        {tags && (
          <div className="flex flex-wrap gap-2 mt-2">
            {tags.map(tag => tag)}
          </div>
        )}
      </div>
      <ColumnButton
        type="button"
        size="sm"
        buttonText="Select"
        primary
        aria-label={`Select ${publisher.label}`}
        onClick={() => onSelect(publisher.value)}
      />
    </div>
  );
}
